export const listeStatuts: { statutLabels: Record<string, string> } = {
  statutLabels: {
    initial: 'Statut initial',
    attente_traitement: 'Envoi par LGG',
    rejetee: 'Rejetée automatiquement',
    invalidee: 'Invalidée',
    attente_action_caisse: 'En attente action caisse',
    a_valider: 'En attente de validation paiement',
    a_payer_automatiquement: 'En paiement',
    a_payer_manuellement: 'En paiement',
    payee: 'En paiement',
    payee_manuellement: 'En paiement',
    a_annuler_automatiquement: 'Annulée',
    a_annuler_manuellement: 'Annulée',
    annulee: 'Annulée',
    annulee_manuellement: 'Annulée manuellement',
    hors_pegase: 'Hors PEGASE'
  }
};

export const ACTIONS = {
  VALIDER_DPA: 1,
  PAIEMENT_MANUEL_REALISE: 2,
  ANNULATION_MANUELLE_REALISEE: 3,
  INVALIDER_DPA: 4
};

export const TYPE_AUTORITE = {
  CONSEIL_ORDRE: 1,
  ARS: 2,
  SYNDICAT: 3
};

export const TYPE_STATUT = {
  A_VALIDER: 'a_valider'
};

export function getStatutLabel(statutId: string): string {
  return listeStatuts.statutLabels[statutId] || 'Statut inconnu';
}
